import { useState, useEffect } from 'react';

const useScrollLock = () => {
    const [isScrollLocked, setIsScrollLocked] = useState(false);

    const enableScrollLock = () => {
        const { body } = document;
    
        if (!body.getAttribute('scrollY')) {
          const pageY = window.pageYOffset;
    
          body.setAttribute('scrollY', pageY.toString());
    
          body.style.position = 'fixed';
          body.style.left = '0px';
          body.style.right = '0px';
          body.style.bottom = '0px';
          body.style.top = `-${pageY}px`;
    
          setIsScrollLocked(true);
        }
    };
      
    const disableScrollLock = () => {
        const { body } = document;
    
        if (body.getAttribute('scrollY')) {
          body.style.removeProperty('overflow');
          body.style.removeProperty('position');
          body.style.removeProperty('top');
          body.style.removeProperty('left');
          body.style.removeProperty('right');
          body.style.removeProperty('bottom');
    
          window.scrollTo(0, Number(body.getAttribute('scrollY')));
    
          body.removeAttribute('scrollY');
    
          setIsScrollLocked(false);
        }
    };

    useEffect(() => {
        // Clean-up function to ensure scroll is unlocked when the component is unmounted
        return () => {
          if (isScrollLocked) {
              disableScrollLock();
          }
        };
    }, [isScrollLocked]);

    return {
        isScrollLocked,
        enableScrollLock,
        disableScrollLock
    };
};

export default useScrollLock;
